<template>
<div>
  <b-card :header="name">
    <Grid v-if="loaded" :name="'filterGrid'+tablename" :ref="'filterGrid'+tablename" v-bind:url="url" v-bind:columns="columns" :pageable='true'  :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
export default {
  name: 'Mpg',
  props: ['url', 'name', 'tablename'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      loaded: false,
      schemaModelFields: {},
      columns: [{
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'updated_at',
        title: 'Atualizado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }, {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  watch: {
    '$route': function(to, from) {
      this.loaded = false
      var that = this
      setTimeout(function() {
        that.loaded = true
      }, 10)
    }
  },
  created() {
    this.loaded = true
  }
}
</script>



// WEBPACK FOOTER //
// grid.vue?2ffd1c6c